<template>
    <div>
        <b-row>
            <b-col sm="6">
                <b-form-group label="Empresa">
                    <el-select id="empresa_descarga_masiva" name="empresa_descarga_masiva" v-model="form.empresa"
                        filterable remote clearable class="w-100" placeholder="Buscar empresa"
                        no-data-text="No hay datos que coincidan" no-match-text="No hay datos que coincidan"
                        :remote-method="getEmpresas">
                        <el-option class="width-select-options" v-for="item in empresas" :key="item.id"
                            :label="item.nombre" :value="item.id">
                        </el-option>
                    </el-select>
                </b-form-group>
            </b-col>
            <b-col sm="6">
                <b-form-group label="Rango de fechas">
                    <el-date-picker v-model="form.fechas" type="daterange" class="w-100" value-format="yyyy-MM-dd"
                        format="yyyy-MM-dd" range-separator="a" start-placeholder="Fecha inicio"
                        end-placeholder="Fecha fin" :picker-options="datePickerOptions" />
                </b-form-group>
            </b-col>
        </b-row>
        <b-row>
            <b-col sm="12" class="text-right">
                <b-button variant="primary" :disabled="submitting" @click="submit">
                    <i class="fa fa-download" />
                    Descargar
                </b-button>
            </b-col>
        </b-row>
    </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { getUuidToUser } from "@/plugins/acl";

export default {
    name: "tickets-descarga-masiva",
    data() {
        return {
            form: {
                empresa: null,
                fechas: [],
            },
            submitting: false,
            datePickerOptions: {
                disabledDate(time) {
                    return time.getTime() > Date.now();
                },
            },
        };
    },
    computed: {
        ...mapState("tickets", ["empresas"]),
    },
    methods: {
        ...mapActions("tickets", ["getEmpresas", "scheduleBulkExportTickets"]),
        async submit() {
            if (!this.form.empresa || !this.form.fechas || this.form.fechas.length !== 2) {
                this.$alertError("Debe seleccionar una empresa y un rango de fechas", 2500, false, "Atención", "warning");
                return;
            }

            this.submitting = true;
            await this.scheduleBulkExportTickets({
                empresa: this.form.empresa,
                desde: this.form.fechas[0],
                hasta: this.form.fechas[1],
                uuid: getUuidToUser(),
            });
            this.submitting = false;

            this.$emit("agendado", this.form.empresa);
        },
    },
};
</script>
